import { useDispatch, useSelector } from "react-redux";
import { featuredFilter } from "../redux/filters/actions";

export default function BooksFilter() {
  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.filters);

  //Dispatch action to switch between all and featured books
  const handleFeaturedFilter = (status) => {
    dispatch(featuredFilter(status));
  };

  return (
    <div className="flex items-center justify-between mb-12">
      <h4 className="mt-2 text-xl font-bold">Book List</h4>
      <div className="flex items-center space-x-4">
        <button
          className={`filter-btn ${status === "All" && "active-filter"} `}
          id="lws-filterAll"
          onClick={() => handleFeaturedFilter("All")}
        >
          All
        </button>
        <button
          className={`filter-btn ${status === "Featured" && "active-filter"}`}
          id="lws-filterFeatured"
          onClick={() => handleFeaturedFilter("Featured")}
        >
          Featured
        </button>
      </div>
    </div>
  );
}
